module.exports = __webpack_public_path__ + "img/tree.9522a900.svg";